class Slideshow2 extends HTMLElement {
  constructor() {
    super();
    // ここでは初期化しない（DOM未確定 & 二重初期化防止）
    this._inited = false;
    this._mainSwiper = null;
    this._thumbSwiper = null;

    // 参照キャッシュ
    this._els = {
      main: null,
      thumb: null,
      next: null,
      prev: null,
      pagination: null,
    };
  }

  static get observedAttributes() {
    // data-autoplay="<ms>" を付けると自動再生
    return ['data-autoplay'];
  }

  connectedCallback() {
    if (this._inited) return;

    // スコープ内で要素を取得（グローバル競合を避ける）
    this._els.main = this.querySelector('.slideshow2__main-slide');
    this._els.thumb = this.querySelector('.slideshow2__thumb-slide');
    this._els.next = this.querySelector('.slideshow2__navigation-next');
    this._els.prev = this.querySelector('.slideshow2__navigation-prev');
    this._els.pagination = this.querySelector('.slideshow2__pagination');

    if (!this._els.main || !this._els.thumb) {
      console.warn('[Slideshow2] 必須要素が見つかりません。 .slideshow2__main-slide / .slideshow2__thumb-slide');
      return;
    }

    // ---- Thumb（サムネイル）: ループ禁止・進捗監視・クリック移動 ----
    this._thumbSwiper = new Swiper(this._els.thumb, {
      slidesPerView: 'auto',
      spaceBetween: 5,
      freeMode: true,
      loop: false,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      // ▼ スクロールバー
      scrollbar: {
        el: this.querySelector('.slideshow2__thumb-scrollbar'),
        draggable: true,   // ツマミをドラッグ可能
        hide: false,       // 常時表示（必要ならtrueで自動非表示）
      },
      breakpoints: {
        990: { spaceBetween: 20 },
      },
    });

    // ---- Main（メイン）: ループ可・thumbs連携 ----
    this._mainSwiper = new Swiper(this._els.main, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 20,
      loop: true, // メイン側はOK（realIndexで同期）
      navigation: (this._els.next && this._els.prev)
        ? { nextEl: this._els.next, prevEl: this._els.prev }
        : undefined,
      thumbs: {
        swiper: this._thumbSwiper, // 先に生成済みのthumbインスタンスを渡す
      },
      breakpoints: {
        990: { spaceBetween: 50 },
      },
      on: {
        // メインが変わる度に、サムネ側の表示位置も明示的に合わせる
        slideChange: () => this._syncThumbPosition(),
      },
    });

    // autoplay属性があれば有効化（安全ガード付き）
    if (this.hasAttribute('data-autoplay')) {
      const delay = Number(this.getAttribute('data-autoplay')) || 4000;
      this._mainSwiper.params.autoplay = { delay, disableOnInteraction: false };
      this._mainSwiper.autoplay?.start?.();
    }

    // 初期位置も合わせる
    this._syncThumbPosition();

    this._inited = true;
  }

  disconnectedCallback() {
    this.destroy();
  }

  attributeChangedCallback(name, _oldValue, newValue) {
    if (name === 'data-autoplay' && this._mainSwiper) {
      const delay = Number(newValue) || 4000;
      this._mainSwiper.params.autoplay = { delay, disableOnInteraction: false };
      this._mainSwiper.autoplay?.start?.();
    }
  }

  // メインの現在位置に合わせて、サムネイルの“表示位置”も追随させる
  _syncThumbPosition() {
    if (!this._mainSwiper || !this._thumbSwiper) return;

    const main = this._mainSwiper;
    const thumb = this._thumbSwiper;

    // loopでも安定するrealIndexを使用
    const idx = main.realIndex;

    if (thumb.params.loop) {
      // もし運用上thumbでloopを使うなら slideToLoop を使用
      thumb.slideToLoop(idx, 300);
      return;
    }

    // thumbが非loopの場合：アクティブを中央付近に見せたい簡易ロジック
    // slidesPerViewが数値ならそれを使用、'auto'なら見積もり
    let perView;
    if (typeof thumb.params.slidesPerView === 'number') {
      perView = thumb.params.slidesPerView;
    } else {
      // 'auto' の概算：最初のスライド幅から一行に入る概数を推定
      const first = thumb.slides[0];
      const size = first ? (first.swiperSlideSize || first.offsetWidth || 1) : 1;
      perView = Math.max(1, Math.floor(thumb.width / size));
    }

    // 中央寄せのための目標indexを計算
    const target = Math.max(idx - Math.floor((perView - 1) / 2), 0);
    thumb.slideTo(target, 300);

    // サムネイルのアクティブ表示を制御
    this._els.thumb.querySelector('.swiper-slide-active').classList.remove('swiper-slide-active');
    const thumbSlide = thumb.slides[idx];
    thumbSlide.classList.add('swiper-slide-active');
  }

  destroy() {
    if (this._mainSwiper && !this._mainSwiper.destroyed) {
      this._mainSwiper.destroy(true, true);
    }
    if (this._thumbSwiper && !this._thumbSwiper.destroyed) {
      this._thumbSwiper.destroy(true, true);
    }
    this._mainSwiper = null;
    this._thumbSwiper = null;
    this._inited = false;
  }
}

customElements.define('slideshow-2', Slideshow2);
